import React from 'react';
import { useNavigate } from 'react-router-dom';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import './NotFound.css';

function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="nf-page">
      <div className="nf-card">
        <div className="nf-icon-wrap">
          <SearchOffIcon className="nf-icon" />
        </div>
        <h1 className="nf-code">404</h1>
        <h2 className="nf-title">Page Not Found</h2>
        <p className="nf-desc">The page you're looking for doesn't exist or has been moved.</p>
        <div className="nf-actions">
          <button className="nf-btn nf-btn-primary" onClick={() => navigate('/verify')}>
            Go to Verify
          </button>
        </div>
      </div>
      <footer className="nf-footer">© 2026 _ Powered by KPITB</footer>
    </div>
  );
}

export default NotFound;
